var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-scrollbar',{ref:"appScrollbar",class:{'app-scrollbar-y': !_vm.scrollX},attrs:{"native":_vm.native}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }